import React, { Component } from 'react';
import WorkExperienceItemForm from './WorkExperienceItemForm'

import {
  Card,
  CardPrimaryAction,
  CardMedia,
  CardAction,
  CardActions,
  CardActionButtons,
  CardActionIcons,
} from 'rmwc/Card';



import { Typography } from 'rmwc/Typography';

class WorkExperienceList extends Component {

   constructor(props) {
      super(props)

     }

   render(){
   var curr = this;

    return this.props.list.map(function(e){
      return (<EditableWorkExperienceForm key ={e.id}
        handleChange = {curr.props.handleChange}
        handleOrganizationChange = {curr.props.handleOrganizationChange}
        onFormSubmit = {curr.props.onFormSubmit}
        handleDeleteItem = {curr.props.handleDeleteItem}
        data={e}/>)
      })
  }
}

class EditableWorkExperienceForm extends React.Component {
  state = {
    isOpen: false,
  };

  handleFormOpen = () => {
    this.setState({ isOpen: true });
    //this.props.handleFormOpen();
  };

  handleFormClose = () => {
    //this.props.handleFormClose();
    this.setState({ isOpen: false });
 };




  handleFormSubmit = (workExp) => {
    this.setState({ isOpen: false });
    this.props.onFormSubmit(workExp);
  };



  render() {
    if (this.state.isOpen) {

      return (
        <WorkExperienceItemForm
          onFormSubmit={this.handleFormSubmit}
          onFormClose={this.handleFormClose}
          onFormChange= {this.props.handleChange}
          onFormOrganizationChange= {this.props.handleOrganizationChange}
          workExpDetails = {this.props.data}
        />
        
      );
    } else {
      return (

                  <Card key={this.props.data.id} style={{ width: '50%' }}>             

              <CardPrimaryAction>
                <div style={{ padding: '0 1rem 1rem 1rem' }}>
                  <Typography use="headline6" tag="h2">
                    {this.props.data.organization}
                  </Typography>
                  <Typography
                    use="body1"
                    tag="div"
                    theme="text-secondary-on-background"
                  >
                  {this.props.data.role}
                  </Typography>

                  <Typography use="body1" tag="div" theme="text-secondary-on-background">
                    {this.props.data.start_date} - {this.props.data.end_date}
                  </Typography>
                </div>
              </CardPrimaryAction>
              {this.props.data.id?
              <CardActions>

                <CardActionIcons>
                  <CardAction icon use="edit" onClick={this.handleFormOpen}/>
                  <CardAction icon use="delete" onClick={ () => this.props.handleDeleteItem(this.props.data.id)} />
                </CardActionIcons>
              </CardActions>:<div style={{display:'none'}}></div>
              }
            </Card>

        );
    }
  }
}

export default WorkExperienceList;



// WEBPACK FOOTER //
// ./src/views/WorkExperienceList.jsx